import isArray from 'lodash-es/isArray';
import isBoolean from 'lodash-es/isBoolean';
import isDate from 'lodash-es/isDate';
import isElement from 'lodash-es/isElement';
import isError from 'lodash-es/isError';
import isFunction from 'lodash-es/isFunction';
import isLength from 'lodash-es/isLength';
import isNaN from 'lodash-es/isNaN';
import isNil from 'lodash-es/isNil';
import isNull from 'lodash-es/isNull';
import isNumber from 'lodash-es/isNumber';
import isObject from 'lodash-es/isObject';
import isObjectLike from 'lodash-es/isObjectLike';
import isString from 'lodash-es/isString';
import isUndefined from 'lodash-es/isUndefined';

import InvalidResourceTypeError from '../errors/InvalidResourceTypeError.js';

export {
    isArray,
    isBoolean,
    isDate,
    isElement,
    isError,
    isFunction,
    isLength,
    isNaN,
    isNil,
    isNull,
    isNumber,
    isObject,
    isObjectLike,
    isString,
    isUndefined,
};


/**
 * Loads a single script or style resource.
 * This function needs to be es5 compatible after it is transpiled.
 * @param {string} url The url of the resource to load
 * @param {string} type The type of the resource. Valid values are 'js' or 'css'
 * @param {function} callback The function that is called when the resource has finished
 * loading.
 * @returns {void}
 */
export const loadResource = function(url, type, callback) {
    //cribbed from ewn

    let loaderElement;

    if (type === 'js') {
        loaderElement = window.document.createElement('script');
        loaderElement.setAttribute('type', 'text/javascript');
        loaderElement.setAttribute('src', url);
    } else if (type === 'css') {
        loaderElement = window.document.createElement('link');
        loaderElement.setAttribute('rel', 'stylesheet');
        loaderElement.setAttribute('type', 'text/css');
        loaderElement.setAttribute('href', url);
    } else {
        const error = new InvalidResourceTypeError(url, type);

        if (isFunction(callback)) {
            callback(error);
        }

        return;
    }

    loaderElement.addEventListener('load', () => {
        if (isFunction(callback)) {
            callback();
        }
    });

    loaderElement.addEventListener('error', (error) => {
        if (isFunction(callback)) {
            callback(error);
        }
    });

    window.document.getElementsByTagName('head')[0].appendChild(loaderElement);
};


// WEBPACK FOOTER //
// ./source/framework/instance/utils.js